(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('VendorFormController', VendorFormController);

  /* ngInject */
  function VendorFormController($state, $stateParams, $window, Flash, branchService, departmentService, customFieldDefinitionService, formErrorsService, riskLevels, sessionService, usStates, vendorService, vendorStatuses) {
    const vm = this;
    /* eslint-disable no-undef */
    let usTimezones = moment.tz.names().filter(zone => zone.includes('US/'));
    let nonUsTimezones = moment.tz.names().filter(zone => !zone.includes('US/'));
    /* eslint-enable no-undef */

    angular.extend(vm, formErrorsService);

    vm.branches = [];
    vm.departments = [];
    vm.customFieldDefinitions = [];
    vm.daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    vm.hoursOfDay = Array.from(Array(24).keys());
    vm.form = {};
    vm.id = $stateParams.id;
    vm.riskLevels = riskLevels;
    vm.saveVendor = saveVendor;
    vm.states = usStates;
    /* eslint-disable no-undef */
    vm.timezones = usTimezones.concat(nonUsTimezones);
    /* eslint-enable no-undef */
    vm.vendor = {};
    vm.vendorStatuses = vendorStatuses;

    activate();

    function activate() {
      angular.element('#risk-level-popover').popover();
      angular.element('#npi-popover').popover();
      angular.element('#third-party-popover').popover();
      angular.element('#foreign-popover').popover();

      if (vm.id) {
        getVendor();
      } else {
        vm.vendor = {};
        vm.vendor.npi_access = false;
        vm.vendor.uses_third_party = false;
        vm.vendor.foreign_based = false;
        vm.vendor.operation_hours = vm.daysOfWeek.map((dayOfWeek, index) => {
          return {
            operation_hour: {
              day_of_week: index,
              is_open: false,
              start_at: 8,
              end_at: 17
            }
          };
        });
      }

      getBranches();
      getDepartments();
      getCustomFieldDefinitions();
    }

    function getCustomFieldDefinitions() {
      customFieldDefinitionService(sessionService.getAuthToken()).query({ class_name: 'Vendor' }, response => {
        vm.customFieldDefinitions = response;
      });
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.id }, response => {
        vm.vendor = response;

        var operationHours = [];
        vm.daysOfWeek.forEach((dayOfWeek, index) => {
          var existingDay = vm.vendor.operation_hours.find(operationHour => operationHour.operation_hour.day_of_week == index);
          if (existingDay) {
            operationHours.push(existingDay);
          } else {
            operationHours.push({
              operation_hour: {
                day_of_week: index,
                is_open: false,
                start_at: null,
                end_at: null
              }
            });
          }
        });
        vm.vendor.operation_hours = operationHours;

        for (var [key, value] of Object.entries(vm.vendor.custom_fields)) {
          vm.vendor[key] = value;
        }
      });
    }

    function getBranches() {
      branchService(sessionService.getAuthToken()).query({}, response => vm.branches = response);
    }

    function getDepartments() {
      departmentService(sessionService.getAuthToken()).query({}, response => vm.departments = response);
    }

    function saveVendor() {
      vm.vendor.operation_hours_attributes = vm.vendor.operation_hours.map(operationHour => operationHour.operation_hour);
      vm.vendor.branches_attributes = vm.vendor.branches;
      vm.vendor.department_attributes = vm.vendor.departments;

      if (vm.id) {
        vendorService(sessionService.getAuthToken()).update({ id: vm.id }, vm.vendor,
          _ => {
            $state.go('application.vms.vendor-detail', { id: vm.id });
            Flash.create('success', 'Vendor successfully updated.');
          }, error => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
            vm.setFormErrors(vm.form, error);
          }
        );
      } else {
        vendorService(sessionService.getAuthToken()).create({}, vm.vendor,
          response => {
            $state.go('application.vms.vendor-detail', { id: response.vendor.id });
            Flash.create('success', 'Vendor successfully created.');
          }, error => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
            vm.setFormErrors(vm.form, error);
          }
        );
      }
    }
  }
})();
